/* Обработчик ошибок в зависимости от статуса и т.д. */
export const apiErrorHandler = (response: any) => {
  switch (response.status) {
    case 403:
    case 406:
      return response.json();
    case 500:
      console.log(`STATUS: ${response.status}, ERROR: ${response.statusText}`);
      return {};
    default:
      return {};
  }
};
